"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSpinnerWrapper = exports.GreyTextDiv = exports.ChartWrapper = exports.ChartContainer = exports.ChartTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ChartTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.black};
	font-size: 1rem;
	font-weight: bold;
`;
exports.ChartContainer = styled_components_1.default.div `
	background-color: #fff;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 300px;
`;
exports.ChartWrapper = styled_components_1.default.div `
	display: flex;
	margin: 1rem 0;
	justify-content: flex-start;
`;
exports.GreyTextDiv = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray6};
`;
exports.ChartSpinnerWrapper = styled_components_1.default.div `
	display: flex;
	height: 100%;
	justify-content: center;
	align-items: center;
`;
